import React from 'react';
import { ArrowHeroCta } from 'components/Icons';
import { ButtonProps, LrButton } from './LrButton';
import './LrButtonArrow.scss';

export const LrButtonArrow = (props: ButtonProps) => {
    const { children, href, onClick, size, variant } = props;
    return (
        <div className="Wrapper-button-arrow">
            <div className="Arrow">
                <ArrowHeroCta />
            </div>
            <LrButton href={href} onClick={onClick} size={size} variant={variant}>
                {children}
            </LrButton>
        </div>
    );
};
